// TIP-609 — one allowance counter.
// Not a boxed tile: a plain column, with a 1px divider drawn between counters
// by the card. Eyebrow, then the figure and its "of N left" tail on one
// baseline, then the note. `tone` shifts all three colours together.
import React from "react";
import "./counterpartyBriefs.css";

const CounterStrip = ({ eyebrow, value, tail, note, tone, testId }) => (
  <div data-testid={testId} className={`cb-counter${tone ? ` cb-counter--${tone}` : ""}`}>
    <span className="cb-counter-eyebrow">{eyebrow}</span>
    <div className="cb-counter-figure">
      <span className="cb-counter-value">{value}</span>
      <span className="cb-counter-tail">{tail}</span>
    </div>
    <p className="cb-counter-note">{note}</p>
  </div>
);

export default CounterStrip;
